<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <chemical-storages-form
      :id="id"
      :title="title"
      :item="item"></chemical-storages-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
